import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import koCommon from './locales/ko/common.json'
import koSidebar from './locales/ko/sidebar.json'
import koHeader from './locales/ko/header.json'
import koAuth from './locales/ko/auth.json'
import koDashboard from './locales/ko/dashboard.json'
import koUsers from './locales/ko/users.json'
import koDeposits from './locales/ko/deposits.json'
import koWithdrawals from './locales/ko/withdrawals.json'
import koTrading from './locales/ko/trading.json'
import koContent from './locales/ko/content.json'
import koPartners from './locales/ko/partners.json'
import koServices from './locales/ko/services.json'
import koStatistics from './locales/ko/statistics.json'
import koModals from './locales/ko/modals.json'
import koMarkets from './locales/ko/markets.json'
import koBalanceTracking from './locales/ko/balanceTracking.json'
import koCompetition from './locales/ko/competition.json'

import enCommon from './locales/en/common.json'
import enSidebar from './locales/en/sidebar.json'
import enHeader from './locales/en/header.json'
import enAuth from './locales/en/auth.json'
import enDashboard from './locales/en/dashboard.json'
import enUsers from './locales/en/users.json'
import enDeposits from './locales/en/deposits.json'
import enWithdrawals from './locales/en/withdrawals.json'
import enTrading from './locales/en/trading.json'
import enContent from './locales/en/content.json'
import enPartners from './locales/en/partners.json'
import enServices from './locales/en/services.json'
import enStatistics from './locales/en/statistics.json'
import enModals from './locales/en/modals.json'
import enMarkets from './locales/en/markets.json'
import enBalanceTracking from './locales/en/balanceTracking.json'
import enCompetition from './locales/en/competition.json'

import jaCommon from './locales/ja/common.json'
import jaSidebar from './locales/ja/sidebar.json'
import jaHeader from './locales/ja/header.json'
import jaAuth from './locales/ja/auth.json'
import jaDashboard from './locales/ja/dashboard.json'
import jaUsers from './locales/ja/users.json'
import jaDeposits from './locales/ja/deposits.json'
import jaWithdrawals from './locales/ja/withdrawals.json'
import jaTrading from './locales/ja/trading.json'
import jaContent from './locales/ja/content.json'
import jaPartners from './locales/ja/partners.json'
import jaServices from './locales/ja/services.json'
import jaStatistics from './locales/ja/statistics.json'
import jaModals from './locales/ja/modals.json'
import jaMarkets from './locales/ja/markets.json'
import jaBalanceTracking from './locales/ja/balanceTracking.json'
import jaCompetition from './locales/ja/competition.json'

import zhCommon from './locales/zh/common.json'
import zhSidebar from './locales/zh/sidebar.json'
import zhHeader from './locales/zh/header.json'
import zhAuth from './locales/zh/auth.json'
import zhDashboard from './locales/zh/dashboard.json'
import zhUsers from './locales/zh/users.json'
import zhDeposits from './locales/zh/deposits.json'
import zhWithdrawals from './locales/zh/withdrawals.json'
import zhTrading from './locales/zh/trading.json'
import zhContent from './locales/zh/content.json'
import zhPartners from './locales/zh/partners.json'
import zhServices from './locales/zh/services.json'
import zhStatistics from './locales/zh/statistics.json'
import zhModals from './locales/zh/modals.json'
import zhMarkets from './locales/zh/markets.json'
import zhBalanceTracking from './locales/zh/balanceTracking.json'
import zhCompetition from './locales/zh/competition.json'

const resources = {
  ko: {
    common: koCommon, sidebar: koSidebar, header: koHeader, auth: koAuth,
    dashboard: koDashboard, users: koUsers, deposits: koDeposits, withdrawals: koWithdrawals,
    trading: koTrading, content: koContent, partners: koPartners, services: koServices,
    statistics: koStatistics, modals: koModals, markets: koMarkets, balanceTracking: koBalanceTracking,
    competition: koCompetition,
  },
  en: {
    common: enCommon, sidebar: enSidebar, header: enHeader, auth: enAuth,
    dashboard: enDashboard, users: enUsers, deposits: enDeposits, withdrawals: enWithdrawals,
    trading: enTrading, content: enContent, partners: enPartners, services: enServices,
    statistics: enStatistics, modals: enModals, markets: enMarkets, balanceTracking: enBalanceTracking,
    competition: enCompetition,
  },
  ja: {
    common: jaCommon, sidebar: jaSidebar, header: jaHeader, auth: jaAuth,
    dashboard: jaDashboard, users: jaUsers, deposits: jaDeposits, withdrawals: jaWithdrawals,
    trading: jaTrading, content: jaContent, partners: jaPartners, services: jaServices,
    statistics: jaStatistics, modals: jaModals, markets: jaMarkets, balanceTracking: jaBalanceTracking,
    competition: jaCompetition,
  },
  zh: {
    common: zhCommon, sidebar: zhSidebar, header: zhHeader, auth: zhAuth,
    dashboard: zhDashboard, users: zhUsers, deposits: zhDeposits, withdrawals: zhWithdrawals,
    trading: zhTrading, content: zhContent, partners: zhPartners, services: zhServices,
    statistics: zhStatistics, modals: zhModals, markets: zhMarkets, balanceTracking: zhBalanceTracking,
    competition: zhCompetition,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ko',
    defaultNS: 'common',
    ns: [
      'common', 'sidebar', 'header', 'auth', 'dashboard', 'users',
      'deposits', 'withdrawals', 'trading', 'content', 'partners',
      'services', 'statistics', 'modals', 'markets', 'balanceTracking',
      'competition',
    ],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'admin_language',
      caches: ['localStorage'],
    },
  })

export default i18n
